import { render, staticRenderFns } from "./GroupAdmin.vue?vue&type=template&id=9c6e9024&scoped=true"
import script from "./GroupAdmin.vue?vue&type=script&lang=js"
export * from "./GroupAdmin.vue?vue&type=script&lang=js"
import style0 from "./GroupAdmin.vue?vue&type=style&index=0&id=9c6e9024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6e9024",
  null
  
)

export default component.exports